/**
 * Cross-platform Datadog ops keys for Heidi Remote 5.0.
 * Emitted via `logHardwareDatadogEvent` / `chronicle:observability`.
 */
export const ScribeRemoteKey = {
  PipelineSelected: 'scribe.remote.pipeline_selected',
  StartRefused: 'scribe.remote.start_refused',
  LevelMeter: 'scribe.remote.level_meter',
  ChunkSealed: 'scribe.remote.chunk_sealed',
  ChunkQueued: 'scribe.remote.chunk_queued',
  ChunkDuplicateSuppressed: 'scribe.remote.chunk_duplicate_suppressed',
  ChunkTransferred: 'scribe.remote.chunk_transferred',
  Reconcile: 'scribe.remote.reconcile',
  LaneDecision: 'scribe.remote.lane_decision',
  TailDrained: 'scribe.remote.tail_drained',
  FinishGate: 'scribe.remote.finish_gate',
  DeviceSessionDeleted: 'scribe.remote.device_session_deleted',
  Recovery: 'scribe.remote.recovery',
} as const;

export type ScribeRemoteKeyName = (typeof ScribeRemoteKey)[keyof typeof ScribeRemoteKey];
